import { render, staticRenderFns } from "./wsNavigation.vue?vue&type=template&id=45711440&scoped=true&"
import script from "./wsNavigation.vue?vue&type=script&lang=js&"
export * from "./wsNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45711440",
  null
  
)

export default component.exports